const fonts = {
    en: "Montserrat, sans-serif",
    ar: "'Noto Naskh Arabic', serif",
    ur: "'Noto Nastaliq Urdu', serif",
};

export default fonts;
